export default __webpack_public_path__ + "img/165cd4c4082b66e678109bee9630fe36.svg";